import script from "./TopHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./TopHeader.vue?vue&type=script&setup=true&lang=ts"

import "./TopHeader.vue?vue&type=style&index=0&id=6f97790e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f97790e"]])

export default __exports__